angular.module('bmsApp.user')
	.controller('ActivateCtrl', [
		'$state',
		'$stateParams',
		'$scope',
		'SetupSvc',
		'AuthService',
		function ($state,
				  $stateParams,
				  $scope,
				  SetupSvc,
				  AuthService) {

			function init() {
				if($stateParams.type == '' || typeof($stateParams.type) === 'undefined'){
					self.form.data.type = 'franchise';
				}else{
					self.form.data.type = $stateParams.type;
				}
				checkKey();
			}

			function checkKey() {
				self.keyChecking = true;
				return SetupSvc.checkKey($stateParams.key, self.form.data.type)
					.then(function (response) {
						self.keyValid = true;
						if($stateParams.type === 'user'){
							self.user = response.data.user;
						}
					}, function (errors) {
						self.keyValid = false;
					})
					.finally(function () {
						self.keyChecked = true;
						self.keyChecking = false;
					});
			}

			function submit() {
				if (!self.form.validator.api.valid()) {
					return false;
				}
				self.form.processing = true;
				SetupSvc.activate(form.data)
					.then(function (response) {
						AuthService.redirect();
					}, function (errors) {
						self.form.errors = errors;
					})
					.finally(function () {
						self.form.processing = false;
					});
			}

			var form = {
				data: {
					password: undefined,
					password_confirmation: undefined,
					key: $stateParams.key
				},
				validator: {
					config: {},
					api: {}
				},
				errors: [],
				processing: false
			};

			var self = $scope.ActivateCtrl = {
				methods: {
					init: init,
					submit: submit
				},
				form: form
			};

		}
	]);
